import { memo, useContext } from 'react';
import { useDrop } from 'react-dnd';
import { Item, ItemTypes, MovableTypePrintingContext } from './MovableTypePrintingProvider';
import GamePrintingMovableType from './GamePrintingMovableType';

export default memo(function Square(props: { index: number }) {
  const { answers, setAnswer } = useContext(MovableTypePrintingContext);
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.CHARACTER,
    drop: (item: Item) => {
      setAnswer(props.index, item);
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }), [props.index])

  let child = null;
  if (answers[props.index]) {
    let temp = answers[props.index] as Item;
    child = (
      <GamePrintingMovableType {...temp} squareIndex={props.index} />
      // <div className={`game-printing-movable-type game-printing-movable-type-${1 + temp.progressIndex}-${1 + temp.imgIndex}`} style={{
      //
      // }}>
      //   {temp.imgIndex}
      // </div>
    )
  }

  return <div ref={drop} className={`game-printing-square${isOver ? ' over' : ''}`} data-index={props.index}>
    {child}
  </div>
}
)
